import { render } from "./Contact.vue?vue&type=template&id=58a814f0"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=58a814f0&lang=css"

import exportComponent from "/home/runner/work/meedly-vueportfolio/meedly-vueportfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__